import { cn } from "@/utils/cn";

/** Single brand accent — matches workspace profiles toolbar title. */
export const accentBarHeadingBarClass = cn(
  "h-6 w-1 shrink-0 rounded-full bg-gradient-to-b from-gradient-purple to-gradient-pink"
);
